/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { SkipForward } from 'lucide-react';
import { FC, memo } from 'react';

import Btn from './Btn';

interface SkipProps {
    onSkip: () => void;
}

const Skip: FC<SkipProps> = ({ onSkip }) => {
    return (
        <Btn label="+ 10 seconds" onClick={onSkip}>
            <SkipForward />
        </Btn>
    );
};

export default memo(Skip);
